import axiosInstance from './axiosConfig';
import { runMailMoves, moveErrorMessage } from './reportSpam';

const isImapMail = (mail) => Boolean(mail && (mail.source === 'imap' || mail.uid));

export const MOVE_FOLDERS = [
  { id: 'inbox', label: 'Inbox' },
  { id: 'archive', label: 'Archive' },
  { id: 'spam', label: 'Spam' },
  { id: 'trash', label: 'Trash' },
];

export function moveMailRequest(mail, destination, fallbackSource = 'inbox') {
  const source = String(mail?.folder || fallbackSource || 'inbox').toLowerCase();
  const normalizedSource = source === 'snooze' ? 'snoozed' : source;
  if (normalizedSource === String(destination || '').toLowerCase()) {
    const error = new Error('Already in that folder');
    error.response = { data: { message: 'Already in that folder' } };
    return Promise.reject(error);
  }
  if (isImapMail(mail)) {
    const uid = mail.uid ?? mail.imapUid;
    if (!uid) return Promise.reject(new Error('Missing message id'));
    return axiosInstance.patch(`/api/mail/server/move/${encodeURIComponent(uid)}`, {
      destination,
      source: normalizedSource,
    });
  }
  const id = mail?._id || mail?.id;
  if (!id) return Promise.reject(new Error('Missing message id'));
  return axiosInstance.patch(`/api/mail/move/${id}`, { destination });
}

export { runMailMoves, moveErrorMessage };
